import { DefaultTheme } from 'styled-components/macro';

export const common: DefaultTheme = {
  // Grayscale palette
  palette_gray_100: '#202532',
  palette_gray_80: '#50545E',
  palette_gray_60: '#838791',
  palette_gray_40: '#BEC0C5',
  palette_gray_10: '#D9DADD',
  palette_gray_5: '#EAEAEB',
  palette_gray_0: '#F2F2F3',

  // Primary palette
  palette_primary_125: '#A5274D',
  palette_primary_100: '#D44A74',
  palette_primary_0: '#F7DEE5',

  // White palette
  palette_white: '#FFFFFF',

  // Support palette
  palette_success_100: '#086343',
  palette_success_50: '#008556',
  palette_success_5: '#D6F3E2',
  palette_warning_100: '#A64F21',
  palette_warning_50: '#E86825',
  palette_warning_5: '#FFE1BE',
  palette_alert_100: '#9F1B1F',
  palette_alert_50: '#DE1C22',
  palette_alert_5: '#FFD6D7',

  // Cafeteria palette
  palette_blue_100: '#5353F6',
  palette_blue_20: '#E8F3FE',
  palette_blue_10: '#F3F1FE',
  palette_blue_5: '#DFDFFB',
  palette_blue_0: '#F3F1FE',

  // Logo palette
  palette_logo_text: '#333333',

  // Breakpoints
  breakpoints_xs: '380px',
  breakpoints_sm: '576px',
  breakpoints_md: '768px',
  breakpoints_lg: '992px',
  breakpoints_xl: '1200px',
  breakpoints_2xl: '1400px',
  breakpoints_3xl: '1600px',

  // Typography
  font_family: "'Poppins', Arial, sans-serif, 'Noto Color Emoji'",

  // Border radius
  border_radius_x1: '4px',
  border_radius_x2: '8px',
  border_radius_infinite: '1000px',

  // Spacing
  spacing_unit_x1: '8px',
  spacing_unit_x2: '16px',
  spacing_unit_x4: '32px',
  spacing_unit_x8: '64px',
  spacing_unit_x16: '128px'
};
